import ImageAccordion from "./components/ImageAccordion.svelte";
import {hydrate} from "svelte";
import {initHomeTestimonials} from "./modules/home-testimonials";
import {initHomeFeatures} from "./modules/home-features";
import {initHomeBrands} from "./modules/home-brands";
import {initTypeWriterEffect} from "./modules/typewriter";


export interface ImageAccordionItem {
    title: string,
    content: string,
    image: string,
}

document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll<HTMLElement>('[data-testimonials]').forEach(element => {
        initHomeTestimonials(element);
    });

    document.querySelectorAll<HTMLElement>('[data-features-effect]').forEach(element => {
        initHomeFeatures(element);
    });

    document.querySelectorAll<HTMLElement>('[data-component="image-accordion"]').forEach(mainElement => {

        const reverse = mainElement.getAttribute('data-reverse') !== null;
        const title = mainElement.querySelector<HTMLElement>('[data-title]')?.innerHTML ?? '';
        const itemElements = mainElement.querySelectorAll<HTMLElement>('[data-items] [data-item]');
        const actionElements = mainElement.querySelector<HTMLElement>('[data-actions]')!;


        if (itemElements) {
            let items: ImageAccordionItem[] = Array.from(itemElements).map(item => {
                const headerEl = item.querySelector<HTMLElement>('[data-item-header]');
                const contentEl = item.querySelector<HTMLElement>('[data-item-content]');
                const imageEl = item.querySelector<HTMLImageElement>('[data-item-image]');
                const videoEl = item.querySelector<HTMLImageElement>('[data-item-video]');

                return {
                    title: headerEl?.textContent?.trim() ?? '',
                    content: contentEl?.innerHTML?.trim() ?? '',
                    image: imageEl?.getAttribute('src') ?? '',
                    video: videoEl?.querySelector('source')?.getAttribute('src') ?? ''
                };
            });
            console.log(items);

            const app = hydrate(ImageAccordion, {
                target: mainElement,
                props: {
                    title,
                    items,
                    reverse,
                    actions: actionElements
                }
            });
        }

    });

    document.querySelectorAll<HTMLElement>('[data-typewriter]').forEach(element => {
        initTypeWriterEffect(element, JSON.parse(element.getAttribute('data-words') ?? ''), 3000)
    })

    document.querySelectorAll<HTMLElement>('[data-brands]').forEach(element => {
        initHomeBrands(element);
    })

})
